import MasterTable from "../../views/dashboard/widget/MasterTabel";
import { useGlobalState } from "../../services/hostelConst.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getClassesList,
  getClassDetails,
  updateClassStatus,
  deleteClass,
  updateClass,
} from "../../services/Academic-Services";
import AddClassesForm from "../../components/FormComponents/AddClasses.js";
const ClassesTabel = () => {
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
  } = useGlobalState();
  useEffect(() => {
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });

    return () => {};
  }, []);

  return (
    <>
      <MasterTable
        getTableData={getClassesList}
        deleteRow={deleteClass}
        updateStatus={updateClassStatus}
        tab1={"Academic"}
        tab2={"Classes"}
        AddForm={AddClassesForm}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
      />
    </>
  );
};

export default ClassesTabel;
